<main id="main-content" tabindex="-1">
  <ng-container [ngTemplateOutlet]="routerOutlet"></ng-container>
</main>
@if ($loading()) {
  <app-global-spinner></app-global-spinner>
}
<app-footer></app-footer>
